'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.readmore = twentyninetimes.readmore || function () {

	function init() {
		const readMoreSections = document.querySelectorAll('.read-more-mobile');
		if ( readMoreSections && window.innerWidth < 768 ) {
			readMoreFunction(readMoreSections)
		}
	}

	function readMoreFunction(sections) {
	    sections.forEach((section) => {
	        if ( section.clientHeight >= 175 ) return;
	        section.classList.add('active');

	        var buttonEl = document.createElement("button");
	        buttonEl.setAttribute('class', 'read-more-mobile__btn');
	        buttonEl.setAttribute('type', 'button');
	        buttonEl.innerHTML = 'Vis mere';

	        section.appendChild(buttonEl);

	        buttonEl.addEventListener('click', (e) => {
	            e.stopPropagation();

	            var heightStart = section.clientHeight;
	            section.style.height = 'auto';
	            var heightNew = section.clientHeight;
	            section.style.height = heightStart+'px';

	            setTimeout(() => {
	                section.style.height = heightNew+'px';
	                section.classList.add('visible');
	            }, 50);

	            setTimeout(() => {
	                section.removeChild(buttonEl);
	                section.style.height = 'auto';
	            }, 550);
	        });
	    });
	}

	return {
		init : init
	};

}();